"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchInfoPaginationYoutube = exports.SearchInfoPagination = exports.SearchInfoWrapper = void 0;
const class_transformer_1 = require("class-transformer");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
class SearchInfoWrapper {
    constructor(searchKey, pagination, result, source = "") {
        this.searchKey = searchKey;
        this.result = result;
        this.source = source;
        this.pagination = new SearchInfoPagination(1);
        this.pagination = pagination;
    }
}
exports.SearchInfoWrapper = SearchInfoWrapper;
__decorate([
    (0, class_transformer_1.Type)(() => SearchInfoPagination)
], SearchInfoWrapper.prototype, "pagination", void 0);
class SearchInfoPagination {
    constructor(page, totalPage, next = undefined, youtube) {
        this.page = page;
        this.totalPage = totalPage;
        this.next = next;
        this.youtube = youtube;
    }
    hasNextPage() {
        if (!(0, is_blank_1.default)(this.youtube?.continuation)) {
            return true;
        }
        if (this.totalPage === undefined) {
            return true;
        }
        if (this.page >= this.totalPage) {
            return false;
        }
        return true;
    }
}
exports.SearchInfoPagination = SearchInfoPagination;
class SearchInfoPaginationYoutube {
    constructor(key, continuation, context) {
        this.key = key;
        this.continuation = continuation;
        this.context = context;
    }
}
exports.SearchInfoPaginationYoutube = SearchInfoPaginationYoutube;
